
/* injects from baggage-loader */

'use strict';

import stageCardTpl from './stage-card.html';
import stageCardController from './stage-card.controller';

export default class StageCardComponent {
    constructor() {
        this.templateUrl = stageCardTpl;
        this.controller = stageCardController;
        this.bindings = {
            title: '@',            
            stage: '=',
            onClick: '&'
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/stage-card/stage-card.component.js